import { RadioList, TextInput } from "@milestone/component-library";
import React from "react";
import { Formik, FormikHelpers } from "formik";
import {
  StatusOptions,
  TeamFormType,
  TeamFormSchema,
  TeamFormHeader,
} from "./teamFormSchema";
import { Header, Section, TopSaveWrapper } from "../../topForm.styles";
import { useHistory } from "react-router-dom";
import search from "../../../../assets/Table/Search.svg";
import { selectMemberMap, selectTeamTypeMap } from "../../../../store/hooks";
import {
  SaveButtonContainer,
  BlueButton,
  OutlineButton,
  ColumnContainer,
  StyledForm,
} from "../../Admin.styles";

interface TeamFormProps {
  header: string;
  submitValues: (
    values: TeamFormType,
    actions: FormikHelpers<TeamFormType>
  ) => void;
  value?: TeamFormType;
  canSave?: boolean;
}

export const TeamForm: React.FC<TeamFormProps> = ({
  header,
  submitValues,
  value,
  canSave = true,
}) => {
  const defaultTeamInfo: TeamFormType = {
    status: StatusOptions[0],
    team: "",
    nickName: "",
    lead: "",
  };

  if (value) {
    if (value.status) defaultTeamInfo.status = value.status;
    if (value.team) defaultTeamInfo.team = value.team;
    if (value.nickName) defaultTeamInfo.nickName = value.nickName;
    if (value.lead) defaultTeamInfo.lead = value.lead;
  }

  const history = useHistory();

  const handleCancel = () => {
    const currentLocation = history.location;
    currentLocation.pathname = "/admin/teams";
    history.push(currentLocation);
  };

  //pull member and teamTypes from redux
  const members = selectMemberMap();
  const teamTypes = selectTeamTypeMap();

  const validateTeam = (value: string) => {
    const teamType = teamTypes.get(value);
    if (!teamType) {
      return "Invalid Team Type";
    }
  };

  const validateLead = (value: string) => {
    const teamLeader = members.get(value);
    if (!teamLeader && value !== "") {
      return "Invalid Team Lead";
    }
    if (teamLeader && teamLeader.teamName && teamLeader.teamName !== value) {
      //commented out now to allow testing TODO put back in later
      //return "Team Lead already part of a team";
    }
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type={canSave ? "submit" : "button"}>Save</BlueButton>
      <OutlineButton type="button" onClick={handleCancel}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  return (
    <ColumnContainer>
      <Formik
        initialValues={defaultTeamInfo}
        validationSchema={TeamFormSchema}
        onSubmit={submitValues}
      >
        {() => (
          <StyledForm>
            <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>
            <Header>{header}</Header>

            <Section>
              {header !== TeamFormHeader.add && (
                <div>
                  <RadioList
                    label="Status"
                    name="status"
                    options={StatusOptions}
                  />
                </div>
              )}

              <TextInput
                name="team"
                label="Team"
                placeholder="Team"
                options={[...teamTypes.keys()]}
                validate={validateTeam}
              />
              <TextInput
                name="nickName"
                label="Team Nickname"
                placeholder="Team Nickname"
              />
              <TextInput
                name="lead"
                label="Team Lead"
                placeholder="Team Lead"
                icon={search}
                options={[...members.keys()]}
                validate={validateLead}
              />
            </Section>
            {/*errors && <div>{JSON.stringify(errors)}</div>*/}
          </StyledForm>
        )}
      </Formik>
    </ColumnContainer>
  );
};
